<template>
  <transition name="fade">
    <v-dialog v-model="dialog" max-width="300" class="rounded-0" persistent scrollable>
      <v-card flat color="#fff" style="border: 5px solid #caad87" v-if="eventX">
        <v-card-title class="d-flex justify-center align-center" style="height: 110px">
          <CloseBtn style="position: absolute; right: 0; top: 0; margin-bottom: 10px" size="30" :callback="() => {
            dialog = false;
          }
            " />
          <div class="text-stroke-sm text-h5 pt-8 text-center">
            {{ eventX.name }}
          </div>
          <div class="d-flex justify-center align-center">
            <CountDown :endTime="eventX.timestampEnd" :message="$t('string.ends_in')" />
          </div>
        </v-card-title>
        <v-card-text style="height: 280px">

          <div class="d-flex justify-center py-2">
            <div>
              <v-img v-if="eventX.imageUrl" :src="eventX.imageUrl" max-width="150">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <v-img v-else :src="require('@/assets/explore/news.png')" max-width="150">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </div>
          </div>
          <div class="text-h6 text-center mb-2">
            <span> {{ playerStars }} / {{ totalStars }} </span> <v-icon color="yellow darken-2 m-2">mdi-star</v-icon>
          </div>
          <div class="text-center">
            <v-btn color="yellow" x-large rounded class="text-h5" @click="clickAction()">{{ $t("action.go") }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </transition>
</template>

<script>
import { mapState } from "vuex";
import delay from "delay";
export default {
  components: {
    CloseBtn: () =>
      import(
        /* webpackChunkName: "component-btn-close" */ "@/components/btns/CloseBtn"
      ),
    CountDown: () =>
      import(
        /* webpackChunkName: "component-countdown" */ "@/components/CountDown.vue"
      ),
  },
  data: () => ({
    dialog: false,
    PlayerApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    eventsApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    LevelsApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    tutorialApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    eventX: null,
    playerStars: 0,
    totalStars: 0
  }),
  computed: mapState({
    settings: (state) => state.settings.data,
    auth: (state) => state.auth.data,
    tutorial: (state) => state.tutorial.data,
  }),
  created() {
    //
  },
  mounted() {
    this.$emit("eventMounted");
  },
  methods: {
    async fetch() {
      if (this.settings && !this.tutorial.Ongoing &&
        (!this.settings.event_reminder_at ||
          !this.$moment(this.settings.event_reminder_at).isSame(this.$moment(), "day"))) {
        await delay(300);
        this.loadEvents();
      }
    },
    async loadTutorials() {
      this.tutorialApi.url =
        this.$api.servers.game +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/tutorial/browse";
      this.tutorialApi.callbackReset = () => {
        this.tutorialApi.isLoading = true;
        this.tutorialApi.isError = false;
        this.tutorialApi.error = null;
      };
      this.tutorialApi.callbackError = (e) => {
        this.tutorialApi.isLoading = false;
        this.tutorialApi.isError = true;
        this.tutorialApi.error = e;
        this.apiError = this.tutorialApi;
      };
      this.tutorialApi.callbackSuccess = async (resp) => {
        this.tutorialApi.isLoading = false;
        if (resp.Tutorial) {
          const keysToCheck = ['tutExploreFamily', 'tutExploreAbc', 'tutExploreShop', 'tutWroldIntro', 'tutExploreEvents', 'tutExploreTower'];
          const hasAllKeys = keysToCheck.every(k => resp.Tutorial.some(item => item.key === k));
          if (hasAllKeys) {
            await this.loadLevels();
            await this.loadPlayer();
          }
        }
      };
      await this.$api.fetch(this.tutorialApi);
    },
    async loadEvents() {
      this.eventsApi.method = "GET";
      this.eventsApi.url =
        this.$api.servers.event +
        "/api/v2/" +
        this.$_getLocale() +
        "/main/event";

      this.eventsApi.callbackReset = () => {
        this.eventsApi.isLoading = true;
        this.eventsApi.isError = false;
      };

      this.eventsApi.callbackError = (e) => {
        this.eventsApi.isLoading = false;
        this.eventsApi.isError = true;
        this.eventsApi.error = e;
        this.apiError = this.eventsApi;
      };
      this.eventsApi.callbackSuccess = async (resp) => {
        this.isOngoingEvent = resp.data.ongoing && resp.data.ongoing.length > 0;
        if (this.isOngoingEvent) {
          this.eventX = resp.data.ongoing[0];
          if (this.eventX.visibility == "public") {
            await this.loadTutorials();
          }
        }
      };
      await this.$api.fetch(this.eventsApi);
    },
    async loadPlayer() {
      this.PlayerApi.url =
        this.$api.servers.event +
        "/api/v2/" +
        this.$_getLocale() +
        "/game/event/player/load";

      this.PlayerApi.callbackReset = () => {
        this.PlayerApi.isLoading = true;
        this.PlayerApi.isError = false;
      };

      this.PlayerApi.callbackError = (e) => {
        this.PlayerApi.isLoading = false;
        this.PlayerApi.isError = true;
        this.PlayerApi.error = e;
      };
      this.PlayerApi.callbackSuccess = (resp) => {
        this.PlayerApi.isLoading = false;
        this.dialog = resp.Player.totalStars != this.totalStars;
        let tempSettings;
        if (this.settings) {
          tempSettings = this.$_.cloneDeep(this.settings);
          tempSettings["event_reminder_at"] = this.$moment().format();
        } else {
          tempSettings = {
            event_reminder_at: this.$moment().format(),
          };
        }
        this.$store.commit("updateSettings", tempSettings);
        this.playerStars = resp.Player.totalStar;
      };
      this.PlayerApi.params = {
        eventCode: this.eventX.code,
        institutionId: this.auth.Institution ? this.auth.Institution.id : null
      };
      this.$api.fetch(this.PlayerApi);
    },
    async loadLevels() {
      this.LevelsApi.url =
        this.$api.servers.event +
        "/api/v1/" +
        this.$_getLocale() +
        "/game/event/level";

      this.LevelsApi.callbackReset = () => {
        this.LevelsApi.isLoading = true;
        this.LevelsApi.isError = false;
      };

      this.LevelsApi.callbackError = (e) => {
        this.LevelsApi.isLoading = false;
        this.LevelsApi.isError = true;
        this.LevelsApi.error = e;
      };
      this.LevelsApi.callbackSuccess = (resp) => {
        this.LevelsApi.isLoading = false;
        this.totalStars = resp.Levels.length * 3;
      };
      this.LevelsApi.params = {
        eventCode: this.eventX.code,
        schoolYear: this.auth.schoolYear,
      };
      this.$api.fetch(this.LevelsApi);
    },
    clickAction() {
      this.$store.commit("updateSeries", this.eventX);
      this.$router.push({
        name: "PageEventLevels",
        params: { code: this.eventX.code },
      });
    },
  },
  beforeDestroy() {
    //
  },
};
</script>
<style scoped>
.text-stroke-sm {
  color: #fff;
  text-shadow: #8b5629 3px 0px 0px, #8b5629 2.83487px 0.981584px 0px,
    #8b5629 2.35766px 1.85511px 0px, #8b5629 1.62091px 2.52441px 0px,
    #8b5629 0.705713px 2.91581px 0px, #8b5629 -0.287171px 2.98622px 0px,
    #8b5629 -1.24844px 2.72789px 0px, #8b5629 -2.07227px 2.16926px 0px,
    #8b5629 -2.66798px 1.37182px 0px, #8b5629 -2.96998px 0.42336px 0px,
    #8b5629 -2.94502px -0.571704px 0px, #8b5629 -2.59586px -1.50383px 0px,
    #8b5629 -1.96093px -2.27041px 0px, #8b5629 -1.11013px -2.78704px 0px,
    #8b5629 -0.137119px -2.99686px 0px, #8b5629 0.850987px -2.87677px 0px,
    #8b5629 1.74541px -2.43999px 0px, #8b5629 2.44769px -1.73459px 0px,
    #8b5629 2.88051px -0.838247px 0px;
}

.bullet-points>div {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.bullet {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  padding: 5px;
  margin: 5px;
}

.bullet-border-blue {
  background-color: #8b5629;
}

.bullet-border {
  background-color: #8b572956;
}

.image-with-halo {
  position: relative;
  display: inline-block;
}

.image-with-halo .v-img {
  display: block;
  border-radius: 50%;
}

.halo {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  content: "";
  border-radius: 50%;
  box-shadow: 0 0 20px #8b5629;
}

.disabled-item-image {
  filter: brightness(0%) contrast(10%) !important;
}

.v-card__text,
.v-card__title {
  word-break: normal !important;
}
</style>
